export default "__VITE_ASSET__DyTi4Fsr__"